<ag-grid-angular
  style="width: 100%; height: 100%"
  [ngClass]="userPrefsService.gridTheme"
  [class]="gridClass"
  [rowHeight]="gridConfig.ROW_HEIGHT"
  [floatingFiltersHeight]="35"
  animateRows
  [pagination]="hasFooter"
  [gridOptions]="gridOptions"
  [rowSelection]="rowSelection"
  [rowData]="rowData"
  (gridReady)="onGridReady($event)"
  (firstDataRendered)="onFirstDataRendered()"
  (modelUpdated)="onModelUpdated()"
>
</ag-grid-angular>
<div *ngIf="hasFooter" class="grid-footer">
  <a *ngIf="hasColSizeButtons" (click)="this.gridOptions?.apiX?.autoSizeAllColumns()">[ Autosize Columns ]</a>
  <a *ngIf="hasColSizeButtons" class="ml-4" (click)="this.gridOptions?.apiX?.sizeColumnsToFit()">[ Size to Fit ]</a>
  <a *ngIf="hasClearFiltersButton" class="ml-4" [hidden]="!hasFilters()" (click)="this.clearAllFilters()">[ Clear all filters ]</a>
</div>
